<template>

  <!-- Presentation Card -->
  <q-card
    @click="$emit('click')"
    class="presentation-card shadow-0 hover-scale-1">

    <!-- Content -->
    <q-card-section
      class="presentation-card__content q-pa-none">

      <div
        class="row full-basis items-stretch no-wrap">

        <!-- Image -->
        <q-img
          :width="'180px'"
          :height="'152px'"
          class="no-shrink xs-hide sm-hide"
          v-if="value.image !== undefined"
          :src="getFileUrl(value.image, 200)"/>

        <div
          class="row items-center full-basis q-px-sm q-py-md">

          <!-- Slot (default) -->
          <div
            class="col q-px-md">

            <h4
              class="text-weight-bold q-mb-xs">

              {{ $u.localize(value.title) }}

            </h4>

            <div
              class="text-body2 text-weight-regular text-gray">

              {{ $u.localize(value.description) }}

            </div>

          </div>

          <!-- Action -->
          <q-btn
            round
            unelevated
            icon="fa lni-download"
            class="presentation-card__action col col-shrink q-mx-md"/>

        </div>

      </div>

    </q-card-section>

  </q-card>

</template>

<script>

  export default {
    name: 'presentation-card',
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
  };

</script>

<style lang="scss">

  .presentation-card {
    color: inherit;
    cursor: pointer;
    overflow: hidden;
    background-color: $grey-2;
    border-radius: $card-radius;

    .text-body1 {
      color: #6A6A6A;
      line-height: 1.2rem;
    }
  }

</style>
